import { render } from "./AllCardsext.vue?vue&type=template&id=5bebec70&scoped=true"
import script from "./AllCardsext.vue?vue&type=script&lang=js"
export * from "./AllCardsext.vue?vue&type=script&lang=js"

import "./AllCardsext.vue?vue&type=style&index=0&id=5bebec70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bebec70"]])

export default __exports__